import React from 'react';
import PropTypes from 'prop-types';
import { NavPillsCardContainer } from 'components/common/Styles';
import { NavPills } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import LeasingIncomeSchemaEventFormulasComponent from './LeasingIncomeSchemaEventFormulasComponent';
import LeasingIncomeSchemaEventNegotiationLimitsComponent from './LeasingIncomeSchemaEventNegotiationLimitsComponent';
import { useReactiveVar } from '@apollo/client';
import { selectedSchemaDetailIdVar } from '../../variables';
import { get, sequence } from '@totalsoft/change-tracking-react';

const LeasingIncomeSchemaEventDetailsComponent = ({ schemaId, lens, validation, disabled, setLimitsInAbsoluteValuesDirty }) => {
  const { t } = useTranslation();
  const selectedSchemaDetailId = useReactiveVar(selectedSchemaDetailIdVar);

  const [detailLens, detailIndex] = (function () {
    let dIndex;
    const dLens = (lens |> sequence).find((detailLens, index) => {
      if ((detailLens.id |> get) === selectedSchemaDetailId) {
        dIndex = index;
        return true;
      }
      return false;
    });
    return [dLens, dIndex];
  })();

  return (
    selectedSchemaDetailId &&
    detailLens && (
      <NavPillsCardContainer p={1}>
        <NavPills
          fullWidth
          tabs={[
            {
              label: t('LeasingIncomeSchema.ApplicabilityAndValueFormulas'),
              content: <LeasingIncomeSchemaEventFormulasComponent lens={detailLens} disabled={disabled} />
            },
            {
              label: t('LeasingIncomeSchema.NegotiationLimits'),
              content: (
                <LeasingIncomeSchemaEventNegotiationLimitsComponent
                  schemaId={schemaId}
                  detailId={detailLens.id |> get}
                  lens={detailLens.negotiationLimits}
                  validation={validation[detailIndex].negotiationLimits}
                  disabled={disabled}
                  setLimitsInAbsoluteValuesDirty={setLimitsInAbsoluteValuesDirty}
                />
              )
            }
          ]}
        />
      </NavPillsCardContainer>
    )
  );
};

LeasingIncomeSchemaEventDetailsComponent.propTypes = {
  schemaId: PropTypes.number,
  lens: PropTypes.object,
  validation: PropTypes.object,
  disabled: PropTypes.bool,
  setLimitsInAbsoluteValuesDirty: PropTypes.func
};

export default LeasingIncomeSchemaEventDetailsComponent;
